import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import 'hammerjs';
import 'zone.js';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { captureRedirectIfProtected, preMarkPunchOut, detectPunchOut } from './app/utils/auth-utils';
if (environment.production) {
  enableProdMode();
}

// Step 1: Store the punchout sid early before Angular bootstraps
preMarkPunchOut();

// Step 2: Detect if this tab is violating punchout session rules
detectPunchOut();

// Step 3: Track intended deep link (if user is not logged in)
captureRedirectIfProtected();

// Step 4: Bootstrap Angular once document is ready
document.addEventListener('DOMContentLoaded', () => {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch(err => console.error(err));
});

